<template>
  <div class="fx_chart_container" :ref="ref">
    <div class="fx_chart_top">
      <slot></slot>
    </div>
    <div :style="{'height':`${chartHeight}`,'flex':1,position:'relative'}">
      <div class="loading" v-show="loading">
        <fxloading1></fxloading1>
      </div>
      <div v-show="isEmpty" class="empty">暂无数据</div>

      <!-- <template v-show="!isEmpty"> -->
        <div class="fx_chart" :ref="chartRef" v-show="!currentVCharts && !isEmpty"></div>
        <component :is="currentVCharts" class="vChart" :height="vChart.vheight" :data="vChartsData"
          :settings="vChart.settings" @ready="afterVChartReady" v-show="currentVCharts && !isEmpty">
        </component>
      <!-- </template> -->
    </div>
  </div>
</template>
<script>
import autoResize from '../../../src/mixins/autoResize'
import { deepMerge, deepClone } from '../../../src/util/index'

import vCharts from '../../../src/mixins/v-charts'

import Echarts from 'echarts'
import 'echarts-liquidfill' //水波球啊！！！

import fxloading1 from '../../fxLoading1/src/main'

export default {
  name: 'fxChart',
  mixins: [autoResize, vCharts],
  components: { fxloading1 },
  data() {
    const timestamp = Date.now()
    return {
      title: '',
      titleStyle: {},
      chartHeight: '100%',
      ref: `chart-container-${timestamp}`,
      chartRef: `chart-${timestamp}`,
      titleRef: `title-${timestamp}`,
      echart: {},
      DVConfig: {}, //大屏配置

      loading: false,
      isEmpty: false, //暂无数据

      currentVCharts: '', //当前的v-charts组件
      vChartsData: {
        columns: '',
        rows: ''
      },
      vChart: {
        vheight: '100%',
        settings: null
      },

      DVEvents: {}
    }
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    events: {
      type: Object
    }
  },
  computed: {},
  watch: {
    config: {
      handler(newVal, oldVal) {
        this.loading = true

        this.initEchart()
      },
      deep: true
    }
  },
  methods: {
    getConfig() {
      let { config, DVConfig } = this
      if (Object.keys(DVConfig).length > 0) {
        return deepMerge(DVConfig, config)
      }
      return deepMerge({}, config)
    },
    initEchart() {
      //初始化echarts实例
      const {
        $refs,
        chartRef,
        config,
        DVConfig,
        getConfig,
        createEventProxy,
        afterEchartReady,
        autoResizeMixinInit,
        
      } = this

      let _config = getConfig() //配置

      const { option } = _config

      if (option === null) {
        //暂无数据
        this.isEmpty = true
        this.echart.clear && this.echart.clear()
        return
      }
      if (!option) return
      //有数据
      this.isEmpty = false
      // this.loading = false
      $refs[chartRef].dispose && $refs[chartRef].dispose()
      const echart = this.echart
      echart.setOption(option)

      createEventProxy()
      afterEchartReady()

      let _this = this
      echart.off('click')
      echart.on('click', function(params) {
        _this.$emit('on-click', params)
      })
    },
    initVchart() {
      this.loading = false
      // console.log(1)
      let { chartType, option, settings } = this.DVConfig
      this.currentVCharts = chartType
      this.vChartsData.columns = option.columns //rows
      this.vChartsData.rows = option.rows //rows
      this.vChart.settings = option.settings
    },

    setLoading(val=false){
      this.loading = val
    },

    //设置config
    setConfig(param = {}) {
      this.DVConfig = Object.assign({}, this.DVConfig, param)

      if (this.DVConfig && this.DVConfig.chartType) {
        //vcharts
        this.initVchart()
      } else {
        //echarts

        this.$nextTick(() => {
          // this.loading = true
          this.initEchart()
        })
      }
    },
    setDVEvents(param = {}) {
      this.DVEvents = Object.assign({}, this.DVEvents, param)
    },
    createEventProxy() {
      // 只要用户使用 on 方法绑定的事件都做一层代理，
      // 是否真正执行相应的事件方法取决于该方法是否仍然存在 events 中
      // 实现 events 的动态响应
      const self = this
      const keys = Object.keys(this.events || {})

      keys.length &&
        keys.forEach(ev => {
          if (this.registeredEvents.indexOf(ev) === -1) {
            this.registeredEvents.push(ev)
            this.echart.on(
              ev,
              (function(ev) {
                return function(...args) {
                  if (ev in self.events) {
                    self.events[ev].apply(null, args)
                  }
                }
              })(ev)
            )
          }
        })
    },

    afterEchartReady() {
      this.$emit('getChartInstance', this.echart)
    },
    afterVChartReady(chart, options, echartsLib) {
      this.$emit('getChartInstance', chart)
    },
    afterAutoResizeMixinInit() {
      const { initEchart } = this
      initEchart()
    },
    onResize() {
      // 自适应
      const { echart } = this
      if (Object.keys(echart).length <= 0) return
      echart.resize()
    },
    getChart() {
      return this.echart
    }
  },
  created() {
    this.registeredEvents = []
  },
  mounted() {
    let { title, titleStyle, option } = this.config
    if (title) {
      this.title = title
    }
    if (titleStyle) {
      this.titleStyle = titleStyle
    }

    if (titleStyle && titleStyle.height) {
      this.chartHeight = `calc( 100% - ${titleStyle.height})`
    } else {
      // this.chartHeight = `calc( 100% - 24px)`;
    }
    let {$refs,chartRef} = this
    // console.log(1);
    this.echart = Echarts.init($refs[chartRef])
  }
}
</script>
<style lang="scss" scoped>
.fx_chart_container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .fx_chart_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
  }
  .fx_chart {
    width: 100%;
    height: 100%;
  }
}

.empty,
.loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background: rgb(7, 6, 40,0.8);
  z-index: 1000;
}
.empty{
  background: rgb(7, 6, 40,0.8);
  z-index: 999;
}

.vChart {
  width: 100%;
  height: 100%;
}
</style>